import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

import ContadorRegressivo from '../components/shared/ContadorRegressivo';
import SeletorCidade from '../components/shared/SeletorCidade';
import TermosDeUso from '../components/TermosDeUso';
import LGPD from '../components/LGPD';
import Regulamento from '../components/Regulamento';

import { useGlobal } from '../contexts/global';
import { isPreConcurso, exibeSeletorCidade } from '../utils/fase';

import iconChat from '../assets/images/icon_chat.png';
import bgPadocaria from '../assets/images/bg_padocaria.png';
import logoPadocaria from '../assets/images/logos/logo-padocaria-26.webp';
import logoOlivasDigital from '../assets/images/logo_olivas_digital.png';

import '../assets/scss/Home.scss';

const HomePrincipal = () => {
  const {
    showRegulamento,
    setShowRegulamento,
    success,
    setSuccess,
    error,
    setError
  } = useGlobal();
  const location = useLocation();
  const preConcurso = isPreConcurso();
  const mostrarSeletor = exibeSeletorCidade();

  useEffect(() => {
    if (error) {
      const errorText =
        typeof error === 'string' && error.trim() !== ''
          ? error
          : 'Erro ao verificar o seu voto. Tente novamente mais tarde.';

      Swal.fire({
        timer: 3500,
        icon: 'error',
        showConfirmButton: false,
        text: errorText,
        didClose: () => {
          setSuccess(false);
          setError(false);
        }
      });
    }

    if (success) {
      Swal.fire({
        timer: 2500,
        icon: 'success',
        showConfirmButton: false,
        html: '<p class="in-home-modal-title">Seu voto foi confirmado com sucesso. Obrigado!</p>',
        didClose: () => {
          setSuccess(false);
          setError(false);
        }
      });
    }
  }, [error, success, setError, setSuccess]);

  return (
    <>
      {/* Modais */}
      {location.pathname.endsWith('/termos-de-uso') && <TermosDeUso />}
      {location.pathname.endsWith('/lgpd') && <LGPD />}
      {showRegulamento && <Regulamento />}

      <div className="home-principal">
        {/* Hero */}
        <section className="in-init">
          <div className="in-init-bg">
            <img src={bgPadocaria} alt="Background Padocaria" />
          </div>
          <div className="in-init-line">
            <hr />
          </div>
          <div className="in-init-ctn">
            <div className="in-init-ctn-grid">
              <div className="in-init-ctn-grid-logo">
                <img src={logoPadocaria} alt="Logo Padocaria" />
              </div>
              <div className="in-init-ctn-grid-info">
                <div className="in-init-ctn-grid-info-icon">
                  <img src={iconChat} alt="Ícone" />
                </div>
                <div className="in-init-ctn-grid-info-title">
                  <p>Em busca da</p>
                  <h1>Melhor Padaria</h1>
                </div>
                <div className="in-init-ctn-grid-info-subtitle">
                  <p>
                    {preConcurso
                      ? 'Em breve você poderá escolher a sua padaria predileta em São Paulo e Belo Horizonte.'
                      : 'Somos um projeto de valorização da história, da cultura, dos produtos, dos serviços e dos profissionais das padarias de São Paulo, Guarulhos e Belo Horizonte.'}
                  </p>
                </div>

                {preConcurso && (
                  <div className="home-principal__contador-wrapper">
                    <ContadorRegressivo />
                  </div>
                )}

                {mostrarSeletor && (
                  <div className="home-principal__seletor-wrapper">
                    <SeletorCidade titulo="Escolha abaixo o local onde quer votar:" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="in-footer">
          <div className="in-footer-ctn no-padding">
            <div className="in-footer-ctn-grid">
              <p>
                Copyright - 2026 | Todos os direitos reservados -{' '}
                <Link to="/lgpd">Política de privacidade</Link> |{' '}
                <Link to="/termos-de-uso">Termos de uso</Link> |{' '}
                <span
                  onClick={() => setShowRegulamento(true)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') setShowRegulamento(true);
                  }}
                >
                  Regulamento
                </span>
              </p>
              <a
                href="https://www.olivas.digital/"
                rel="noreferrer"
                target="_blank"
              >
                <img src={logoOlivasDigital} alt="Olivas Digital" />
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HomePrincipal;
